export default {"src":"/_next/static/media/soap.2ecd1f86.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};